import React from "react";
import LayoutSection from "../../layouts/layoutSection";
import TitreSection from "../ui/typographic/titreSection";
import TextSection from "../ui/typographic/textSection";
import Legend from "../ui/typographic/legend";
import ButtonTertiary from "../ui/buttons/tertiary";
import { Link } from "gatsby";
import { useInView } from 'react-intersection-observer';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { GuillemetHautGauche } from "../../svgIcons/guillemetHautGauche";
import { Guillemet } from "../../svgIcons/guillemet";

const QuoteFull = ({ lineStep, content, extraclass, pics }) => {
  const { ref: divdRef, inView: divIsVisible } = useInView({
    threshold: 1,
    triggerOnce: true
  });

  const Pics = pics.edges
  let res = Pics.filter(pic => pic.node.name === content.photo)

  return (
    <LayoutSection
      lineStep={lineStep}
      type=''
      colorBckgd='x-light-violet-bckd'
      extraclass={extraclass}
      full
    >
      <GuillemetHautGauche color='#efeeff' info='absolute top-0 left-0' size={60} />
      <GuillemetHautGauche color='#efeeff' info='absolute bottom-0 right-0 rotate-180' size={60} />
      <div className="container mx-auto my-8 md:grid md:content-center md:gap-8 md:grid-cols-12">
        <div className="row-start-3 col-span-12 mb-4 md:mb-0 md:col-span-6 md:col-start-8 md:row-start-1">
          <div className="flex items-center justify-center gap-4">
            <div className="flex-none circle-anime w-24 h-24">
              {
                divIsVisible ?
                  <GatsbyImage
                    image={getImage(res[0].node)}
                    alt={content.auteur}
                  />
                  : ''
              }
            </div>
            <div className=" flex-1">
              <p className="mb-1 leading-4 font-medium">{content.auteur}</p>
              <p className="leading-4">{content.position}</p>
            </div>
          </div>
        </div>

        <div className="col-span-12 mb-4 md:mb-0 md:col-span-6 md:row-start-2 md:text-right">
          <Legend
            content={content.soustitre}
            inView={divIsVisible}
            reference={divdRef}
          />
          <TitreSection
            content={content.titre}
            size={4}
            inView={divIsVisible}
            reference={divdRef}
          />
        </div>

        <div className="col-span-12 md:col-start-8">
          <div className=" relative">
            <Guillemet color='#efeeff' size={100} info='-left-10 -top-4 z-0 absolute' />
            <TextSection
              content={content.description}
              size='m'
              extra='relative z-10 mb-4'
              inView={divIsVisible}
              reference={divdRef}
            />
            <Link to="/votre-projet">
              <ButtonTertiary
                cta="J’aimerais être contacté"
                color='orange'
              />
            </Link>
          </div>
        </div>
      </div>

    </LayoutSection>
  )
}


export default QuoteFull
